"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PX_WIDTH_DEFAULT = exports.PC_WIDTH_DEFAULT = exports.MIN_WIDTH_UNIT = exports.MIN_WIDTH = void 0;
exports.isPercentageUnit = isPercentageUnit;

/**
 * Constants
 */
const PC_WIDTH_DEFAULT = 50;
exports.PC_WIDTH_DEFAULT = PC_WIDTH_DEFAULT;
const PX_WIDTH_DEFAULT = 350;
exports.PX_WIDTH_DEFAULT = PX_WIDTH_DEFAULT;
const MIN_WIDTH = 220;
exports.MIN_WIDTH = MIN_WIDTH;
const MIN_WIDTH_UNIT = 'px';
/**
 * Returns a boolean whether passed unit is percentage
 *
 * @param {string} unit Block width unit.
 *
 * @return {boolean} 	Whether unit is '%'.
 */

exports.MIN_WIDTH_UNIT = MIN_WIDTH_UNIT;

function isPercentageUnit(unit) {
  return unit === '%';
}
//# sourceMappingURL=utils.js.map